import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Box, Icon, InlineMessage } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import {
  CAMPAIGN_TYPES,
  CAMPAIGNTYPE_ENTITLEMENTOWNER,
} from '../../../utils/constant';
import { useInvertedLocalize } from '../../../utils/localization';
import { getMessageKey } from '../../../utils/utils';
import {
  BULK_ACTION_FOOTER_BTNS_REVERSE,
  BULK_ACTION_FOOTER_OBJECTS,
  BULK_ACTION_FOOTER_OBJECTS_MESSGAE_KEYS,
  BULK_ACTION_OBJ_USERS,
  getBulkActionFooterBtns,
} from '../constant';
import { invertedMessages } from '../messages';

function BulkActionEndDateSubTitle({ id, bulkFooterStats }) {
  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user);
  const l = useInvertedLocalize(invertedMessages);
  const {
    core: { campaignType },
    lineActions: { reassignConfigMap },
  } = useSelector((state) => state?.certifications?.details);
  const isEOCampaign =
    CAMPAIGN_TYPES[campaignType] === CAMPAIGNTYPE_ENTITLEMENTOWNER;

  const { showSelfCertificationNote } = reassignConfigMap;

  const getSubtitleContent = () => {
    const buttonKey = BULK_ACTION_FOOTER_BTNS_REVERSE?.[id];
    const buttonObjectsForTotal = getBulkActionFooterBtns(
      campaignType,
      reassignConfigMap
    )[buttonKey]?.objectsToTotal;

    const tempSubtitleText = buttonObjectsForTotal
      ?.filter((key) => bulkFooterStats[key] > 0)
      .map((key) => {
        const messageKey =
          BULK_ACTION_FOOTER_OBJECTS_MESSGAE_KEYS[
            `${BULK_ACTION_FOOTER_OBJECTS[key]}${
              bulkFooterStats[key] > 1 ? 's' : ''
            }`
          ];

        return `${
          messages.messageKey || localize(intl, getMessageKey(messageKey))
        } (${bulkFooterStats[key]})`;
      });

    if (!tempSubtitleText) return '';

    if (tempSubtitleText?.length === 0) {
      return (
        messages.CERTS_BULK_NOTHING_SELECTED ||
        localize(intl, getMessageKey('CERTS_BULK_NOTHING_SELECTED'))
      );
    }

    if (tempSubtitleText?.length === 1) {
      if (!bulkFooterStats?.[BULK_ACTION_OBJ_USERS]) {
        return `${
          messages.CERTS_BULK_CED_SELECTED ||
          localize(intl, getMessageKey('CERTS_BULK_CED_SELECTED'))
        } ${tempSubtitleText[0]}. ${
          messages.CERT_BULK_ENDDATE_SUFFIX_MESSAGE ||
          localize(intl, getMessageKey('CERT_BULK_ENDDATE_SUFFIX_MESSAGE'))
        } ${
          messages['BULKACTION.common.reject.INLINE_MESSAGE.ATTESTATIONS'] ||
          localize(
            intl,
            getMessageKey('BULKACTION.common.reject.INLINE_MESSAGE')
          )
        }`;
      }

      return `${
        messages.CERTS_BULK_CED_SELECTED ||
        localize(intl, getMessageKey('CERTS_BULK_CED_SELECTED'))
      } ${tempSubtitleText[0]}. ${
        messages.CERT_BULK_ENDDATE_SUFFIX_MESSAGE ||
        localize(intl, getMessageKey('CERT_BULK_ENDDATE_SUFFIX_MESSAGE'))
      }`;
    }

    const subtitle = tempSubtitleText
      .slice(0, tempSubtitleText.length - 1)
      .join(', ');

    if (!bulkFooterStats?.[BULK_ACTION_OBJ_USERS]) {
      return `${
        messages.CERTS_BULK_CED_SELECTED ||
        localize(intl, getMessageKey('CERTS_BULK_CED_SELECTED'))
      }${subtitle} ${
        messages.CERTS_BULK_AND ||
        localize(intl, getMessageKey('CERTS_BULK_AND'))
      } ${tempSubtitleText[tempSubtitleText.length - 1]}. ${
        messages.CERT_BULK_ENDDATE_SUFFIX_MESSAGE ||
        localize(intl, getMessageKey('CERT_BULK_ENDDATE_SUFFIX_MESSAGE'))
      } ${
        messages['BULKACTION.common.reject.INLINE_MESSAGE.ATTESTATIONS'] ||
        localize(intl, getMessageKey('BULKACTION.common.reject.INLINE_MESSAGE'))
      }`;
    }

    return `${
      messages.CERTS_BULK_CED_SELECTED ||
      localize(intl, getMessageKey('CERTS_BULK_CED_SELECTED'))
    } ${subtitle} ${
      messages.CERTS_BULK_AND || localize(intl, getMessageKey('CERTS_BULK_AND'))
    } ${tempSubtitleText[tempSubtitleText.length - 1]}. ${
      messages.CERT_BULK_ENDDATE_SUFFIX_MESSAGE ||
      localize(intl, getMessageKey('CERT_BULK_ENDDATE_SUFFIX_MESSAGE'))
    }`;
  };

  return (
    <Box>
      {getSubtitleContent()}
      {isEOCampaign && Boolean(showSelfCertificationNote) && (
        <InlineMessage
          className='BulkActionEndDateSubTitle-inlineMessage'
          text={l(
            'Action will not be applied for access items that belong to the certifier.'
          )}
          colorTheme='info'
          size='medium'
          leftIcon={<Icon kind='AlertInfoFilled' />}
        />
      )}
    </Box>
  );
}

BulkActionEndDateSubTitle.propTypes = {
  id: PropTypes.string.isRequired,
  bulkFooterStats: PropTypes.shape({}),
};

BulkActionEndDateSubTitle.defaultProps = { bulkFooterStats: {} };

export default BulkActionEndDateSubTitle;
